import { AdminIcon, DocumentIcon, HomeDollarIcon, HomeIcon, LogoutIcon, SettingsIcon, UserIcon } from '@/icons';
import { ROUTES } from '@/models/router.model';
import { ItemType } from 'antd/es/menu/interface';
import { TFunction } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';
import { StyledButton } from '../components/Styled';

export const getTopMenuConfig = (t: TFunction, navigate: NavigateFunction): ItemType[] => [
  {
    icon: <HomeIcon />,
    label: <span>{t('sidebar_properties_in_progress')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.PROPERTIES,
    title: t('sidebar_properties_in_progress'),
  },
  {
    icon: <HomeDollarIcon />,
    label: <span>{t('sidebar_properties_sold')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.PROPERTIES_SOLD,
    title: t('sidebar_properties_sold'),
  },
  {
    icon: <UserIcon />,
    label: <span>{t('sidebar_users')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.USERS,
    title: t('sidebar_users'),
  },
  {
    icon: <DocumentIcon />,
    label: <span>{t('sidebar_orders')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.ORDERS,
    title: t('sidebar_orders'),
  },
];

export const getBottomMenuConfig = (t: TFunction, navigate: NavigateFunction, onClick: () => void): ItemType[] => [
  {
    icon: <AdminIcon />,
    label: <span>{t('sidebar_admins')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.ADMINS,
    title: t('sidebar_admins'),
  },
  {
    icon: <SettingsIcon />,
    label: <span>{t('sidebar_settings')}</span>,
    onClick: ({ key }) => navigate(key),
    key: ROUTES.SETTINGS,
    title: t('sidebar_settings'),
  },
  {
    icon: <LogoutIcon />,
    label: <StyledButton onClick={onClick}>{t('sidebar_logout')}</StyledButton>,
    onClick: () => onClick?.(),
    title: t('sidebar_logout'),
    key: 'logout',
  },
];
